import * as Address from '@/services/rest-api/lib/delivery/address'

export const originFields = [
  {
    name: 'origin_address_id',
    showKey: 'origin_address.id',
    type: 'value-help-v2',
    label: 'Alamat Asal',
    placeholder: 'Pilih Alamat Asal',
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Address.get(),
    classCol: 'col-12',
    tableFields: [
      {
        label: 'Nama Lokasi',
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: 'Kategori Alamat',
        key: 'category',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: 'Alamat Lengkap',
        key: 'full_name',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: 'Provinsi',
        key: 'province',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: 'Kota',
        key: 'city',
        isSortable: true,
        isRedirectable: true,
      },
    ],
    gridColSpan: 2,
  },
  {
    name: 'expected_pickup_on_interval',
    showKey: 'expected_pickup_on_interval',
    label: 'Target Diambil',
    placeholder: '00 Hari 00 Jam',
    type: 'time-duration',
    tooltip: 'Target muatan diambil setelah No. Pengiriman dibuat',
    classCol: 'col-12 col-md-6',
    optionItems: [
      {
        key: 'days',
        items: [0, 1, 2, 3, 4, 5],
      },
      {
        key: 'hours',
        items: [0, 1, 2, 3, 4, 5],
      },
    ],
  },
]

export const destinationFields = [
  {
    name: 'destination_address_id',
    showKey: 'destination_address.id',
    type: 'value-help-v2',
    label: 'Alamat Tujuan',
    placeholder: 'Pilih Alamat Tujuan',
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Address.get(),
    classCol: 'col-12',
    tableFields: [
      {
        label: 'Nama Lokasi',
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: 'Kategori Alamat',
        key: 'category',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: 'Alamat Lengkap',
        key: 'full_name',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: 'Provinsi',
        key: 'province',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: 'Kota',
        key: 'city',
        isSortable: true,
        isRedirectable: true,
      },
    ],
    gridColSpan: 2,
  },
  {
    name: 'expected_delivered_on_interval',
    showKey: 'expected_delivered_on_interval',
    label: 'Target Terkirim',
    placeholder: '00 Hari 00 Jam',
    type: 'time-duration',
    tooltip: 'Target muatan dikirim ke pelanggan setelah No. Pengiriman dibuat.',
    classCol: 'col-12 col-md-6',
    optionItems: [
      {
        key: 'days',
        items: [0, 1, 2, 3, 4, 5],
      },
      {
        key: 'hours',
        items: [0, 1, 2, 3, 4, 5],
      },
    ],
  },
]